import { css } from "styled-components";

/**
 * Due to increased css specificity in antdV5,
 * we cannot use ant-input className in components that are not Input
 * (eg: in Audit Input)
 *
 * These styles are copied from antdV5 dev console - Elements
 **/
export const AntInputV5Styled = css`

`;
